<div class="prose mb-8">
  <h1>
    {{ 'pages.uploadFile.title' | translate }}
  </h1>
  <h2>
    {{ 'pages.uploadFile.teaser' | translate }}
  </h2>
</div>

<nz-steps class="mb-6!" [nzCurrent]="currentStep">
  <nz-step [nzTitle]="'pages.uploadFile.steps.metadata.title' | translate" />
  <nz-step [nzTitle]="'pages.uploadFile.steps.upload.title' | translate" />
  <nz-step
    class="[&_.ant-progress-inner]:size-full!"
    [nzStatus]="totalProcessStatus"
    [nzTitle]="'pages.uploadFile.steps.progress.title' | translate"
    [nzPercentage]="totalProcess"
  />
</nz-steps>

@if (currentStep === Step.metadata) {
  <app-step-metadata
    data-test-id="metadataStep"
    [metaDataModel]="metaDataModel"
    (metaDataModelChange)="onMetaDataModelChange($event)"
    (stepCompleted)="onMetadataStepCompleted()"
  />
}

@if (currentStep === Step.upload) {
  <app-step-upload
    data-test-id="uploadStep"
    (fileSelected)="onFileSelected($event)"
    (stepCompleted)="onUploadStepCompleted()"
  />
}

@if (currentStep === Step.progress) {
  <app-step-progress
    data-test-id="progressStep"
    [metaDataModel]="metaDataModel"
    [file]="file!"
    [fileLineCount]="fileLineCount"
    (backToUpload)="onBackToUpload()"
    (progressUpdate)="onProgressUpdate($event)"
  />
}
